import { render, staticRenderFns } from "./PicklOverview.vue?vue&type=template&id=c61b9e76&scoped=true&"
import script from "./PicklOverview.vue?vue&type=script&lang=js&"
export * from "./PicklOverview.vue?vue&type=script&lang=js&"
import style0 from "./PicklOverview.vue?vue&type=style&index=0&id=c61b9e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61b9e76",
  null
  
)

export default component.exports